import { formatToCurrencyFloat } from 'app/utils/normalizer';

export const formatInterestRate = (
  interestRate?: string | number,
): number | undefined => {
  if (
    interestRate === undefined ||
    interestRate === null ||
    interestRate === ''
  )
    return undefined;

  const floatStr = formatToCurrencyFloat(interestRate);
  const parsed = parseFloat(floatStr);

  if (isNaN(parsed)) return undefined;

  const precision = parsed >= 10 ? 4 : 3; // ex: 1,23% => 0.0123
  return parseFloat((parsed / 100).toPrecision(precision));
};
